import QboQuotes from './qboQuotes';

export default QboQuotes;
